@import '../../../../style/src/typography/mixins';

:host {
	@include zds-typography('body');
}

.zds-input-counter {
	color: var(--zds-text-color-muted);
	display: flex;
	font-family: monospace;
	font-size: var(--zds-font-size-xs);
	justify-content: flex-end;
	opacity: 0;
	padding-right: var(--zds-space-2);
	padding-top: var(--zds-space-2);
	position: relative;
	transition: all 300ms var(--zds-transition-type-ease-out-shake);
	visibility: hidden;

	&--visible {
		opacity: 1;
		visibility: visible;
	}

	&--warning {
		color: var(--zds-text-color-base);
	}

	> span {
		padding-left: var(--zds-space-1);
		text-align: right;
	}

	&__counter-icon {
		opacity: 0;
		transform: translateX(5px);
		transition: all 300ms var(--zds-transition-type-ease-out-shake);

		&--warning {
			color: var(--zds-color-warning);
			opacity: 1;
			transform: none;
		}

		&--danger {
			color: var(--zds-color-danger);
		}
	}
}
